// extracted by mini-css-extract-plugin
module.exports = {"categoriesContainer":"Corporate_categoriesContainer__V2ESQ","corpContainer":"Corporate_corpContainer__iEo4_","mainContainer":"Corporate_mainContainer__7wQSQ"};